import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "place/environment"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getResume(type, param, allStatus = false) {

        return http.getResume(path,type,param,allStatus);

    }

    getAllEnvironmentByEnterpriseId(enterpriseId) {

        if (enterpriseId > 0) {

            let params = new URLSearchParams()
            params.set("enterpriseId", enterpriseId)
            return http.list(path + "/selectAll",params);

        } else{

            return Promise.reject("")

        }
    }


}

export default new service();

